import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './components'
import './plugins/vant'
import './assets/normalize.css'
import './assets/base.less'

Vue.config.productionTip = false

Vue.prototype.$IMG_BASE_URL = 'https://chezhihui-1254182596.file.myqcloud.com/chezhihui'

Vue.prototype.$zhangtao = ''

store.dispatch('getEncodeInfo')

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
